'use client';

import { motion } from "framer-motion";
import Image from "next/image";

export function PartnerLogos() {
  const partners = [
    { name: "Google Cloud", logo: "/partner-logos/google-cloud.svg" },
    { name: "AWS", logo: "/partner-logos/aws.svg" },
    { name: "IBM", logo: "/partner-logos/ibm.svg" },
    { name: "Microsoft Azure", logo: "/partner-logos/azure.svg" },
    { name: "OpenAI", logo: "/partner-logos/openai.svg" },
    { name: "NVIDIA", logo: "/partner-logos/nvidia.svg" },
    { name: "Arduino", logo: "/partner-logos/arduino.svg" },
    { name: "Raspberry Pi", logo: "/partner-logos/raspberry-pi.png" },
    { name: "Android", logo: "/partner-logos/icons8-android-logo.svg" },
    { name: "Apache Kafka", logo: "/partner-logos/icons8-apache-kafka.svg" },
    { name: "Deepseek", logo: "/partner-logos/icons8-deepseek.svg" },
    { name: "Firebase", logo: "/partner-logos/icons8-firebase.svg" },
    { name: "Grafana", logo: "/partner-logos/icons8-grafana.svg" },
    { name: "JavaScript", logo: "/partner-logos/icons8-javascript.svg" },
    { name: "Microsoft", logo: "/partner-logos/icons8-microsoft.svg" },
    { name: "OpenCV", logo: "/partner-logos/icons8-opencv.svg" },
    { name: "PostgreSQL", logo: "/partner-logos/icons8-postgresql.svg" },
    { name: "Power BI", logo: "/partner-logos/icons8-power-bi-logo.svg" },
    { name: "Prometheus", logo: "/partner-logos/icons8-prometheus.svg" },
    { name: "Selenium", logo: "/partner-logos/icons8-selenium-logo.svg" },
    { name: "Tableau", logo: "/partner-logos/icons8-tableau-software.svg" },
    { name: "Terraform", logo: "/partner-logos/icons8-terraform-logo.svg" },
    { name: "YOLO", logo: "/partner-logos/icons8-yolo.svg" },
    { name: "LangGraph", logo: "/partner-logos/langgraph-color.svg" }
  ];

  return (
    <div className="py-16 bg-white">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">Trusted Technology Collaborations</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We collaborate with industry-leading platforms to deliver cutting-edge solutions
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex flex-wrap justify-center items-center gap-6 md:gap-10"
        >
          {partners.map((partner) => (
            <div 
              key={partner.name}
              className="w-28 h-16 relative grayscale hover:grayscale-0 transition-all duration-300"
            >
              <Image
                src={partner.logo}
                alt={`${partner.name} logo`}
                fill
                className="object-contain"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
} 